<div [formGroup]="formData" *ngIf="formReady" class="searchFormContainer comparablesSearchContainer comparablesValuationsSearchContainer">
  <table aria-hidden="true">
    <tbody>
      <tr *ngIf="selectedItemType==='comparablesProperty'">
        <td class="LabelContainer">
          <br />
          <span class="dialogLabel">
            {{selectedItem?.Oid}}: {{selectedDesc}}
          </span>
        </td>
      </tr>

      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'comparablesProperty.city' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <input style="width: 100%" formControlName="city" />
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'comparablesProperty.postalCode' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <input style="width: 100%" formControlName="postalCode" />
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'comparablesProperty.street' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <input style="width: 100%" formControlName="street" />
        </td>
      </tr>

      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'comparablesValuation.valuationDate' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <div>
            <div class="comparablesSearchFromToInput">
              <input type="date" class="date-input" formControlName="valuationDateFrom">
            </div>
            <div class="comparablesSearchFromToInput">
              <input type="date" class="date-input" formControlName="valuationDateTo">
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'comparablesValuation.walt' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <div class="dual-input-field-container">
            <div class="comparablesSearchFromToInput">
              <kendo-numerictextbox formControlName="waltFrom" format="n0" [spinners]="false"></kendo-numerictextbox>
            </div>
            <div class="comparablesSearchFromToInput">
              <kendo-numerictextbox formControlName="waltTo" format="n0" [spinners]="false"></kendo-numerictextbox>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'comparablesValuation.vacancy' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <div class="dual-input-field-container">
            <div class="comparablesSearchFromToInput">
              <kendo-numerictextbox formControlName="vacancyFrom" format="n0" [spinners]="false"></kendo-numerictextbox>
            </div>
            <div class="comparablesSearchFromToInput">
              <kendo-numerictextbox formControlName="vacancyTo" format="n0" [spinners]="false"></kendo-numerictextbox>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
